import 'bootstrap/dist/css/bootstrap.min.css';

import { Outlet, Route, Routes } from 'react-router-dom';

import Home from './pages/Home';
import Footer from './components/navigation/Footer';
import { Header } from './components/navigation/Header';
import { EURegulation } from './pages/EURegulation';
import { Mission } from './pages/Mission';
import { Support } from './pages/Support';
import { PrivacPolicy } from './pages/PrivacyPolicy';
import { ConfidentialityAgreement } from './pages/ConfidentialityAgreement';
import React, { useState } from 'react';
import TermOfUse from './pages/TermOfUse';
import ContactUs from './pages/ContactUs/ContactUs';
import ScrollToTop from './hooks/ScrollToTop';
import CookieConsent from "react-cookie-consent";
import AppPermission from './pages/AppPermission';
import AboutUs from './pages/AboutUs';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import DonateForm from './pages/DonateForm/DonateForm';
import { getRouteData } from './helpers/getRouteData';

const {stripe_key} = getRouteData()

const stripePromise = loadStripe(stripe_key);

function App() {

  const [, setCookiesAccepted] = useState(false)

  const handleDeny = () => {
    // console.log("NO COOKIE", cookiesAccepted)
  }

  return (
    <>
    <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Deny"
        enableDeclineButton
        onAccept={() => setCookiesAccepted(true)}
        onDecline={handleDeny}
        style={{ background: "#2B373B" }}
        buttonStyle={{ 
          backgroundColor: "#7684FF", 
          color: "#fff", 
          fontSize: "13px", 
          borderRadius: 9999 
        }}
        declineButtonStyle={{ 
          backgroundColor: "transparent", 
          border: "0.5px solid #7684FF", 
          color: "#7684FF", 
          fontSize: "13px", 
          borderRadius: 9999 
        }}
        expires={365}
    >
      This website uses cookies to enhance the user experience.
    </CookieConsent>
    <Routes>
      <Route path="/" element={
        <>
          <ScrollToTop />
          <Outlet />
          <Footer />
        </>
      }>
        <Route index element={<Home />} />
      </Route>
      <Route element={
        <>
          <ScrollToTop />
          <Header />
          <Outlet />
          <Footer />
        </>
      }>
      <Route
        path="/donate-form"
        element={
          stripePromise ? (
            <Elements stripe={stripePromise}>
              <DonateForm />
            </Elements>
          ) : (
            <div className='loader'>Loading...</div>
          )
        }
      />
        <Route path="/eu_regulation" element={<EURegulation />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy_policy" element={<PrivacPolicy />} />
        <Route path="/app_permission" element={<AppPermission />} />
        <Route path="/confidentiality_agreement" element={<ConfidentialityAgreement />} />
        <Route path="/terms_of_use" element={<TermOfUse />} />
        <Route path="/contact_us" element={<ContactUs />} />
        <Route path="/about_us" element={<AboutUs />} />
      </Route>
    </Routes>
    </>
  )
}

export default App;
